import { WS_API_ENDPOINTS } from '../config/api';
import { fetchWithAuth } from '../utils/auth';

export interface GrowthAudit {
  generatedAt: string;
  since: string;
  accounts: Array<{
    username: string; name: string;
    season: { stage: number; earnedXP: number; boughtXP: number; missionsCompleted: number; currentDailyXP: number; currentWeeklyXP: number; seasonMissionXP: number; updatedAt: string } | null;
    permanent: { earnedXP: number; boughtXP: number; missionAwardCount: number; giftSpendAwardCount?: number; top100AwardRecorded: boolean } | null;
    wallet: { total: number; reward: number; purchased: number; gifted: number } | null;
    ledger: { credits: number; debits: number; expectedBalance: number; reconciles: boolean; sources: Array<{ type: string; source: string; entries: number; tokens: number }> };
    verifiedPurchaseCredits: number; unverifiedPurchaseCredits: number;
    recentGiftFunding: { receivedTokens: number; senderCount: number; largestSenderSharePercent: number };
    recentGiftSpend?: { entries: number; sentTokens: number; purchasedTokensUsed: number; giftedTokensUsed: number; rewardTokensUsed: number; unclassifiedTokens: number };
    cashout: { applicationStatus: string | null; reviewedAt: string | null; holdUntil: string | null; holdActive: boolean | null; withdrawals: Array<{ status: string; entries: number; tokens: number }> };
  }>;
  pair: Array<{ from: string; to: string; sends: number; sentTokens: number; receiverEntries: number; receivedTokens: number; reconciles: boolean; liveContexts: number; first: string | null; last: string | null; daily: Array<{ day: string; sends: number; tokens: number }> }>;
  reviewSignals: { reciprocalGifting: boolean; unreconciledGiftLedger: boolean; concentratedGiftFunding: boolean; unreconciledWallet: boolean };
  limits: string[];
}

export async function getGrowthAudit(first: string, second: string, since: string): Promise<GrowthAudit> {
  const query = new URLSearchParams({ first, second, since });
  const response = await fetchWithAuth(`${WS_API_ENDPOINTS.prod}/admin/wallet/growth-audit?${query}`);
  const json = await response.json().catch(() => null);
  if (!response.ok) throw new Error(json?.message || 'Unable to load the review');
  return json?.data as GrowthAudit;
}
